export default __webpack_public_path__ + "static/media/Settings.1af69380.png";